module.exports = __webpack_public_path__ + "static/media/abt_icon.96239b80.svg";